import { css, cx } from '@linaria/core'
import { type FC, Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import { Spinner } from '#components/Spinner'
import { PageHeader } from '#features/AppLayout/Header/PageHeader'
import { PageHeaderContext } from '#features/AppLayout/Header/PageHeaderContext'
import { PageLayout } from '#features/AppLayout/PageLayout'

const mainClass = css`
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: hidden;
  max-height: calc((100vh * var(--inverse-zoom)) - var(--header-height, 72px));

  @media print {
    max-height: unset;
    overflow: visible;
  }
`

export const PageRouteOutlet: FC<{ appName: string }> = ({ appName }) => {
  const { t } = useTranslation('shared')

  return (
    <PageHeaderContext>
      <PageLayout>
        <PageHeader appName={appName} />
        <main className={cx(mainClass)}>
          <Suspense fallback={<Spinner size="xl" subtitle={t('app.loading-data', 'Loading…')} />}>
            <Outlet />
          </Suspense>
        </main>
      </PageLayout>
    </PageHeaderContext>
  )
}
